module.exports = __webpack_public_path__ + "img/2.1da14670.png";